import $ from "jquery";
import "popper.js"; // Bootstrap requires this
import "bootstrap";
import "fslightbox";
import "slick-carousel";
// import "./js/cookies.js";
import "./js/smooth-scroll.js";
// import Player from "@vimeo/player"; TODO: This import is broken

// Can import modules as needed
// ex. import 'bootstrap/js/dist/dropdown';

import "./scss/style.scss";

// This is for slick carousels
global.jQuery = global.$ = require('jquery');

// # ---------------------------------------------------------------
// # Custom Methods...
(function ($) {
  $(function () {

    // Utility function to check if element is visible
    function isVisible($el) {
      var winTop = $(window).scrollTop();
      var winBottom = winTop + $(window).height();
      var elTop = $el.offset().top;
      var elBottom = elTop + $el.height();
      return ((elBottom <= winBottom) && (elTop >= winTop));
    }

    // Toggle nav open class
    // Toggle nav open class with 1s delay on close
    $('.navbar-toggler').on('click', function () {
      const $header = $('#site-header');

      if ($header.hasClass('nav-open')) {
        // delay removal
        setTimeout(function () {
          $header.removeClass('nav-open');
        }, 400);
      } else {
        // add immediately
        $header.addClass('nav-open');
      }
    });

    // Toggle nav scroll class
    var header = $('#site-header'); // adjust selector if needed
    var scrollTop = 300;

    $(window).on('scroll', function () {
      header.toggleClass('scrolled', $(this).scrollTop() > scrollTop);
    });

    // Adjust top padding to header height
    var headerNav = $('#header-navigation');
    var body = $('body');

    function adjustBodyPadding() {
      if (!headerNav.length) return;

      // Only for non transparent-header on mobile
      // And all headers mobile up
      var isSmallScreen = window.innerWidth < 992;
      var headerHeight = headerNav.outerHeight(true);

       if (isSmallScreen && !header.hasClass('transparent') || !isSmallScreen) {
        body.css('padding-top', headerHeight);
      } else {
        body.css('padding-top', '');
      }
    }

    // Run on load
    adjustBodyPadding();

    // Run on resize
    $(window).on('resize', function () {
      adjustBodyPadding();
    });

    // Hide Header on on scroll down
    var delta, didScroll, hasScrolled, lastScrollTop, navbarHeight;
    didScroll = void 0;
    lastScrollTop = 0;
    delta = 5;
    navbarHeight = $('header#site-header').outerHeight();

    hasScrolled = function () {
      var st;
      st = $(window).scrollTop();
      if (Math.abs(lastScrollTop - st) <= delta) {
        return;
      }
      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('header').removeClass('nav-down').addClass('nav-up');

      } else {
        //Scroll Up
        if (st + $(window).height() < $(document).height()) {
          $('header').removeClass('nav-up').addClass('nav-down');
        }
      }
      lastScrollTop = st;
    };

    $(window).scroll(function (event) {
      didScroll = true;
    });

    setInterval((function () {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }), 150);
    // END Hide Header on on scroll down


    // Slick sliders
    $(function () {

      $('.slick-slider--products').each(function () {
        let $this = $(this);

        $this.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: false,
          autoplay: false,
          prevArrow:
            '<a class="slick-prev"><i class="bi bi-chevron-left"></i></a>',
          nextArrow:
            '<a class="slick-next"><i class="bi bi-chevron-right"></i></i></a>',

          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              }
            },
          ],
        });
      });


      $('.slick-slider--mobile-only').each(function () {
        let $this = $(this);

        $this.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: false,
          autoplay: false,
          prevArrow:
            '<a class="slick-prev"><i class="bi bi-chevron-left"></i></a>',
          nextArrow:
            '<a class="slick-next"><i class="bi bi-chevron-right"></i></i></a>',
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: "unslick"
            },
          ],
        });
      });

      $('.slick-hero-slider').each(function () {
        let $this = $(this);

        $this.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 6000,
          prevArrow:
            '<a class="slick-prev"><i class="bi bi-chevron-left"></i></a>',
          nextArrow:
            '<a class="slick-next"><i class="bi bi-chevron-right"></i></i></a>',
        });
      });


      $('.slick-testimonial-slider').each(function () {
        let $this = $(this);

        $this.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: false,
          autoplay: false,
          prevArrow:
            '<a class="slick-prev"><i class="bi bi-chevron-left"></i></a>',
          nextArrow:
            '<a class="slick-next"><i class="bi bi-chevron-right"></i></i></a>',
        });
      });

    });

    // Animated counter block
    function animateCounter($counter) {
      $counter.prop('Counter', $counter.data('startnum')).animate({
        Counter: $counter.data('endnum')
      }, {
        duration: $counter.data('duration'),
        easing: 'swing',
        step: function (now) {
          // Does not have decimal or a comma
          $counter.children('.text').text(Number(this.Counter).toFixed(0).toLocaleString('en'));
        }
      });
      $counter.addClass('animation-done');
    }

    // Function to check and animate visible counters
    function checkAnimatedCounters() {
      $('.animated-counter').each(function () {
        if (isVisible($(this))) {
          if (!$(this).hasClass('animation-done')) {
            animateCounter($(this));
          }
        }
      });
    }

    // Run on document ready
    $(document).ready(function () {
      checkAnimatedCounters();
    });

    // Run again on scroll
    $(window).scroll(function () {
      checkAnimatedCounters();
    });
    // END Animated Counter


    // Product Filters
    // TODO: For mobile hide all except first 6 upon filtering
    // hide/show the load more button accordingly 
    const $filterSelect = $('#shop-filter-select');
    const $clearButton = $('#clear-filters-btn');
    const $allProducts = $('ul.products.filterable li.product');
    const $loadMoreBtn = $('#load-more-posts');

    var itemsPerPage = 6;
    var visibleCount = itemsPerPage;

    /* ---------- Helpers ---------- */

    function isMobile() {
      return $(window).width() < 768;
    }

    function getVisibleProducts() {
      return $allProducts.filter('.is-visible');
    }

    function updateView() {
      const $visibleProducts = getVisibleProducts();

      $allProducts.hide();
      visibleCount = itemsPerPage;

      if (isMobile()) {
        $visibleProducts.slice(0, visibleCount).fadeIn(200);

        if ($visibleProducts.length > visibleCount) {
          $loadMoreBtn.show();
        } else {
          $loadMoreBtn.hide();
        }
      } else {
        $visibleProducts.fadeIn(200);
        $loadMoreBtn.hide();
      }
    }

    /* ---------- Filtering ---------- */

    function filterProducts(category) {
      $allProducts.removeClass('is-visible').hide();

      if (!category) {
        $clearButton.removeClass('active');
        $allProducts.addClass('is-visible');
      } else {
        $clearButton.addClass('active');
        $allProducts
          .filter('.product_cat-' + category)
          .addClass('is-visible');
      }

      updateView();
    }

    /* ---------- Events ---------- */

    // Filter change
    $filterSelect.on('change', function () {
      filterProducts($(this).val());
    });

    // Clear filters
    $clearButton.on('click', function (e) {
      e.preventDefault();
      $filterSelect.val('');
      filterProducts('');
    });

    // Resize
    $(window).on('resize', function () {
      updateView();
    });

    // Load more
    $loadMoreBtn.on('click', function () {
      const $visibleProducts = getVisibleProducts();
      const nextCount = visibleCount + itemsPerPage;

      $visibleProducts.slice(visibleCount, nextCount).fadeIn(200);
      visibleCount = nextCount;

      if (visibleCount >= $visibleProducts.length) {
        $(this).hide();
      }
    });

    /* ---------- Init ---------- */
    filterProducts('');


  });

})($);
